<template>
  <section class="section">
    <div class="container">
      <h1 class="title">
        Customer Addresses Selected vs Not Selected
      </h1>
      <b-field grouped>
        <b-field label="Date From" expanded>
          <b-datetimepicker
            rounded
            placeholder="Click to select..."
            icon="calendar-today"
            :datepicker="{ showWeekNumber }"
            :timepicker="{ enableSeconds }"
            v-model="fromDate"
          ></b-datetimepicker>
        </b-field>
        <b-field label="Date To" expanded>
          <b-datetimepicker
            rounded
            placeholder="Click to select..."
            icon="calendar-today"
            :datepicker="{ showWeekNumber }"
            :timepicker="{ enableSeconds }"
            v-model="toDate"
          ></b-datetimepicker>
        </b-field>
        <b-field label="Ignore Non Pickups" expanded>
          <b-checkbox v-model="ignoreNonPickups"> </b-checkbox>
        </b-field>
      </b-field>
    </div>
    <div class="container">
      <section>
        <b-button v-on:click="filterAdded" class="button is-primary">Submit</b-button>
      </section>
    </div>
    <div class="container" v-if="initialSubmit">
      <bar-chart :chart-data="overallChartData" :styles="myStyles" />
    </div>
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
  </section>
</template>

<script>
import axios from "axios";
const GlobalConfig = require("../../config/index");
var dateFormat = require("dateformat");
import BarChart from "@/components/Charts/BarChart.vue";

export default {
  name: "ProviderRequests",
  components: { BarChart },
  data: function() {
    return {
      initialSubmit: false,
      fromDate: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 00:00:00"),
      toDate: new Date(new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() + " 23:59:59"),
      providers: [],
      showWeekNumber: false,
      filteringDate: false,
      enableSeconds: true,
      isLoading: false,
      ignoreNonPickups: true,
      overallChartData: {
        labels: [],
        datasets: []
      }
    };
  },
  beforeMount() {},
  computed: {
    myStyles() {
      return {
        height: `600px`,
        position: "relative"
      };
    }
  },
  methods: {
    filterAdded: async function() {
      this.filteringDate = true;
      this.isLoading = true;
      await this.LoadCustomerBreakdown();
      this.isLoading = false;
      this.initialSubmit = true;
    },
    LoadCustomerBreakdown: async function() {
      const token = await this.$cognitoAuth.getIdToken();
      const config = {
        headers: { Authorization: `Bearer ${token}` }
      };
      const customerSelectedStats = await axios.get(
        `${GlobalConfig.GetAPIURL()}/api/stats/requests/selectedbreakdown?dateFrom=${dateFormat(this.fromDate, "isoDateTime").split("+")[0]}Z` +
          `&dateTo=${dateFormat(this.toDate, "isoDateTime").split("+")[0]}Z&ignoreNonPickups=${this.ignoreNonPickups}`,
        config
      );

      let chartData = { datasets: [], labels: [] };

      const notSelected = [];
      const selected = [];

      for (const value of customerSelectedStats.data) {
        chartData.labels.push(value.CustomerName);
        notSelected.push(value.NotSelected);
        selected.push(value.Selected);
      }

      chartData.datasets.push({
        type: "bar",
        label: "Selected",
        backgroundColor: "#00d11c",
        fillColor: "#00d11c",
        data: selected
      });

      chartData.datasets.push({
        type: "bar",
        label: "NotSelected",
        backgroundColor: "#d60015",
        fillColor: "#d60015",
        data: notSelected
      });

      this.overallChartData = chartData;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
